import { Button } from "antd";
import React, { useRef } from "react";
import "./style.scss";
import { ModalCustom, Notification } from "components/common";
import { receiveService } from "api";
import SignSecure from "./components/SignSecure";
import { siderData } from "layout/main-layout/sider/sider.config";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";

const SignSecureNew = () => {
  const signSecureRef = useRef<any>();
  const onClick = async () => {
    try {
      const res = await receiveService.getSignByPatient();
      console.log("🚀 ~ onClick ~ res:", res);
      // signSecureRef.current.clearSign();
      if (res.statusCodeValue === 400) {
        Notification("warning", res.body);
        return;
      }
      signSecureRef.current.setThongTinBN(res);
      signSecureRef.current.openModal();
    } catch (error) {
      console.log("🚀 ~ onClick ~ error:", error);
      Notification("error", error.response.data);
    }
  };
  return (
    <div className="container" style={{ height: "80vh" }}>
      <div className="sign-secure">
        <Button
          id="btn-ki-bao-mat"
          type="primary"
          className="btn-sub "
          onClick={onClick}
        >
          Ký bảo mật
        </Button>
      </div>
      <SignSecure modalRef={signSecureRef} />
    </div>
  );
};

export default SignSecureNew;
